import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  fetchEmailStatistics,
  fetchPartnerMiniStatistics,
  fetchSmsStatistics,
  type ReportRange,
} from "@/api/adminReports";

export const useEmailStatistics = (range: ReportRange, page: number, search: string) =>
  useQuery({
    queryKey: ["admin-email-statistics", range, page, search.trim()],
    queryFn: () => fetchEmailStatistics({ range, page, search, perPage: 25 }),
    staleTime: 45_000,
    placeholderData: keepPreviousData,
  });

export const useSmsStatistics = (days: 7 | 14 | 30) =>
  useQuery({
    queryKey: ["admin-sms-statistics", days],
    queryFn: () => fetchSmsStatistics(days),
    staleTime: 45_000,
  });

export const usePartnerMiniStatistics = () =>
  useQuery({
    queryKey: ["admin-partner-mini-statistics"],
    queryFn: fetchPartnerMiniStatistics,
    staleTime: 60_000,
  });
